import KeyStringCollection from "../../collections/key-string-value";
import environment from "../../common/environment";

const NAReasonCodes = KeyStringCollection.extend({
  url: environment.getEndpoint("chart-reviews:na-reason-codes"),
  initialize() {
    this.promise = this.fetch();
  },
});

export { NAReasonCodes as default };
